export default __webpack_public_path__ + "static/media/img1.506d9a7a.svg";